<template>
  <div style="padding-top: 20px; padding-bottom: 20px;">
    <b-img center alt="K-9 Logo"
      src="https://res.cloudinary.com/dbl4yeqf9/image/upload/v1676427443/logos/logo_corp_fc_egpbiw.png"
      width="150" height="140">
    </b-img>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
